<form [formGroup]="mainForm" id="top">
  <app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
  <h1>宛名印刷登録</h1>
  <mat-card class="cur-card">
    <app-sgkd019d-sendto-search
      [businessDate]="businessDate"
      (responseEmitter)="setResponse($event)"
      (clearMessageEvent)="clearMessage()"
    />
    <app-sgkd019d-sendto-info
      (clearMessageEvent)="clearMessage()"
    />
    <app-sgkd019d-hakkomoto
      (clearMessageEvent)="clearMessage()"
    />
    <mat-card-content>
      <div fxLayout="row wrap" fxLayoutAlign="end center">
        <mat-card-actions class="btn_area_right">
          <button type="button" mat-raised-button
            color="primary"
            class="btn btnPrint"
            [disabled]="isDisabledBtnPrint()"
            (click)="onClickPrint()">印刷</button>
        </mat-card-actions>
        <mat-card-actions class="btn_area_right">
          <button type="button" mat-raised-button
            color="primary"
            class="btn btnPrev"
            (click)="goToPrevious()">戻る</button>
        </mat-card-actions>
      </div>
    </mat-card-content>
  </mat-card>
</form>
